import React, { useState, useRef, useEffect } from 'react';
import './Win98Dialog.css';

const Win98Dialog = ({ 
  title, 
  icon = null, 
  children, 
  onClose, 
  onMinimize = null, 
  onMaximize = null,
  buttons = [],
  width = 'auto',
  height = 'auto',
  draggable = true
}) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const dialogRef = useRef(null);
  const titleBarRef = useRef(null);

  useEffect(() => {
    // Center dialog on mount
    if (dialogRef.current) {
      const rect = dialogRef.current.getBoundingClientRect();
      setPosition({
        x: (window.innerWidth - rect.width) / 2,
        y: (window.innerHeight - rect.height) / 2
      });
    }
  }, []);

  const handleMouseDown = (e) => {
    if (!draggable || e.target.closest('.win98-dialog-controls')) return;
    setIsDragging(true);
    const rect = dialogRef.current.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging) {
        setPosition({
          x: e.clientX - dragOffset.x,
          y: e.clientY - dragOffset.y
        });
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, dragOffset]);

  return (
    <div className="win98-dialog-overlay" onClick={onClose}>
      <div
        ref={dialogRef}
        className="win98-dialog"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          width: width !== 'auto' ? `${width}px` : 'auto',
          height: height !== 'auto' ? `${height}px` : 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          ref={titleBarRef}
          className="win98-dialog-titlebar"
          onMouseDown={handleMouseDown}
          style={{ cursor: draggable ? 'move' : 'default' }}
        >
          <div className="win98-dialog-title">
            {icon && <span className="win98-dialog-icon">{icon}</span>}
            <span>{title}</span>
          </div>
          <div className="win98-dialog-controls">
            {onMinimize && (
              <button
                className="win98-dialog-button"
                onClick={(e) => {
                  e.stopPropagation();
                  onMinimize();
                }}
                title="Minimize"
              >
                _
              </button>
            )}
            {onMaximize && (
              <button
                className="win98-dialog-button"
                onClick={(e) => {
                  e.stopPropagation();
                  onMaximize();
                }}
                title="Maximize"
              >
                □
              </button>
            )}
            <button
              className="win98-dialog-button"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              title="Close"
            >
              ×
            </button>
          </div>
        </div>
        <div className="win98-dialog-content">
          {children}
        </div>
        {buttons.length > 0 && (
          <div className="win98-dialog-footer">
            {buttons.map((button, index) => (
              <button
                key={index}
                className="win98-system-button"
                onClick={button.onClick}
                style={button.style || {}}
              >
                {button.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Win98Dialog;





